import React from "react"
import KomodoImg from "../../../images/komodo.svg"
import CoworkingImg from "../../../images/coworking.svg"
import MountainImg from "../../../images/mountain.svg"
import SofaImg from "../../../images/sofa.svg"
import BbqGrillImg from "../../../images/bbq-grill.svg"
import GymImg from "../../../images/gym.svg"
import SwimmingPoolImg from "../../../images/swimming-pool.svg"

const Komodo = () => {
  return (
    <>
      <section className="container mx-auto px-6 pt-20">
        <div className="flex flex-col-reverse md:flex-row items-center">
          <div className="w-full md:w-2/3 pt-4">
            <h2 className="text-5xl pb-8 font-light">
              <span className="text-quaternary block font-semibold text-6xl">
                Komodo
              </span>{" "}
              Ecuador
            </h2>
            <h3 className="text-5xl pb-4 text-quaternary font-medium">
              Our Orchard
            </h3>
            <h4 className="text-3xl pb-4 text-quaternary font-medium">
              Merging the quiet life of a jungle town with personal and
              professional evolution.
            </h4>
            <p className="text-xl pb-4">
              With the purpose of achieving a unique experience, we created
              Komodo, a place of work, rest, generator of friendships, teams and
              more!
            </p>
          </div>
          <div className="w-full md:w-1/3">
            <img src={KomodoImg} alt="Komodo Ecuador" className="mx-auto" />
          </div>
        </div>

        <div className="container mx-auto px-6 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-center font-medium">
            <div>
              <img
                src={CoworkingImg}
                alt="Co-working space with fiber optic connection"
                className="mx-auto"
              />
              <p>Co-working space with fiber optic connection</p>
            </div>
            <div>
              <img
                src={MountainImg}
                alt="Mountain bikes wheeled 26"
                className="mx-auto"
              />
              <p>Mountain bikes wheeled 26</p>
            </div>
            <div>
              <img
                src={SofaImg}
                alt="4 co-living homes, equipped for four people"
                className="mx-auto"
              />
              <p>4 co-living homes, equipped for four people</p>
            </div>
            <div>
              <img
                src={BbqGrillImg}
                alt="Fully equipped barbecue"
                className="mx-auto"
              />
              <p>Fully equipped barbecue</p>
            </div>
            <div>
              <img src={GymImg} alt="Training sector" className="mx-auto" />
              <p>Training sector</p>
            </div>
            <div>
              <img
                src={SwimmingPoolImg}
                alt="Relaxation pool"
                className="mx-auto"
              />
              <p>Relaxation pool</p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-tertiary text-white px-6 py-12">
          <p className="container mx-auto text-center w-1/2 text-2xl">The experience in <span className="text-tertiary">Komodo</span> will make time fly. We want you to enjoy new ways to develop professionally as if you were on vacation.</p>
      </section>
    </>
  )
}

export default Komodo
